import { InputPhone } from 'shared/ui';
import { InputMethodProps } from './model';

export const FieldPhone = (props: InputMethodProps) => (
  <InputPhone
    onChangePhone={(value) => props.onChange(value)}
    value={props.value || ''}
  />
);
